export enum OpenBankingTransactionStatusEnum {
    InProgress,
    Canceled,
    Confirmed,
    Error
}